import { Box, Typography } from '@mui/material';

import { COMING_SOON_SX } from '../styles';

export default function ComingSoon() {
  return (
    <Box sx={COMING_SOON_SX}>
      <Typography>Coming soon</Typography>
    </Box>
  );
}
